exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!./assets/index.less"), "");

// module
exports.push([module.id, "\n.admintag {\n    background-color: #333;\n    color: #fff;\n    padding: 2px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    margin-right: 10px;\n}\n.zengpin {\n    border: 1px solid #20bf64;\n    border-radius: 4px;\n    width: 18px;\n    height: 16px;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    line-height: 16px;\n    color: #20bf64;\n    margin-left: 8px;\n    margin-right: 8px;\n}\n.admintag:hover {\n    cursor: pointer;\n}\n.ivu-drawer-body {\n    padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f5e0471","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 7yxm
// module chunks = 142